import React from "react";
import { Grid, Box, Typography, Avatar } from "@mui/material";
import { themes } from "../../themes/themes";

interface PropVal {
  emp_name: string;
  status: any;
  department?: string;
  designation: string;
  leave_day: number;
  leave_type?: string;
}
const LeaveInsightArTile = ({
  designation,
  emp_name,
  department,
  leave_day,
  status,
  leave_type,
}: PropVal) => {
  return (
    <Box
      style={{
        backgroundColor: "#F5F5FA66",
        height: "auto",
        padding: "1em",
        borderRadius: "10px",
        marginTop: "1em",
        display: "flex",
      }}
    >
      <Box>
        <Avatar />
      </Box>
      <Box style={{ paddingLeft: "5px" }}>
        <Typography
          style={{
            fontFamily: "Lato",
            color: themes.darkBlue,
            fontSize: "0.875em",
            fontWeight: "bold",
          }}
        >
          {emp_name}
        </Typography>
        <Typography
          style={{
            fontFamily: "Lato",
            color: themes.grey_colorDesignationAR,
            fontSize: "0.75em",
            fontWeight: "bold",
          }}
        >
          {department}/{designation}
        </Typography>
        <Typography
          style={{
            fontFamily: "Lato",
            color: themes.greySubtitle,
            fontSize: "0.75em",
            fontWeight: "bold",
          }}
        >
          {leave_type} {"        "}{" "}
          <span style={{ color: themes.defaultScondary_blue }}>
            {leave_day >= 1 ? `${leave_day} Day` : `${leave_day} Days`}
          </span>
        </Typography>
      </Box>
      <Box
        style={{
          backgroundColor: "#FFEDEF",
          padding: "3px",
          borderRadius: "4px",
          alignSelf: "flex-start",
        }}
      >
        <Typography
          style={{
            fontFamily: "Lato",
            color: themes.lightRedSubtittle,
            fontSize: "0.7em",
            fontWeight: "bold",
            alignSelf: "center",
          }}
        >
          {status == 0 ? "Pending" : status == 1 ? "Approved" : "Rejected"}
        </Typography>
      </Box>
    </Box>
  );
};

export default LeaveInsightArTile;
